<template>
  <div>
    <page-content-header :item="item" />
    <section class="content-section">
      <b-container>
        <b-row>
          <b-col>
            <page-content-creator
              :itemid="itemid"
              pos="top"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <node-element-local-tasks
              v-if="itemid"
              :itemid="itemid"
            />
            <div
              v-if="notpublished"
              class="messages warning"
            >Not published</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <page-content-wysiwg-content
              v-if="hasBody"
              :item="item"
            />
            <div
              v-if="drupalmode"
              class="attached-view"
              v-html="attachedView"
            />
            <div
              v-if="icmsmode"
              class="attached-view"
            >
              <template v-for="(listItem, key) in listItems">
                <component
                  :is="itemComponent"
                  :item="listItem"
                  :key="key"
                />
              </template>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <page-content-creator
        :itemid="itemid"
        pos="bottom"
      />
    </section>
  </div>
</template>

<script>
import { asyncData, pageMixin } from '../content-type-page-common'

export default {
  name: 'page-content-type-page',
  asyncData: args => asyncData(args),
  mixins: [pageMixin],
  props: {
    nid: {
      type: [Number, String],
      required: false,
      default: () => {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

.content-section {
  padding: 3em 0em;
}
.content-skeleton {
  background: #eef1f5;
  width: 100%;
  min-height: 800px;
  padding-top: 30%;
}
</style>
